import React, { useState } from "react";
import useInstallPrompt from "@/hooks/useInstallPrompt";
import { DownloadSimple, X, DeviceMobile } from "@phosphor-icons/react";

export default function InstallPrompt() {
  const { canInstall, isIOS, hasNativePrompt, promptInstall } = useInstallPrompt();
  const [dismissed, setDismissed] = useState(!!localStorage.getItem("ac_install_dismissed"));

  if (!canInstall || dismissed) return null;

  const install = async () => { await promptInstall(); setDismissed(true); };
  const dismiss = () => { localStorage.setItem("ac_install_dismissed", "1"); setDismissed(true); };

  return (
    <div className="fixed bottom-6 left-6 z-50 max-w-xs bg-[#0f0f12] border-2 border-[#FFD600] shadow-[0_0_30px_rgba(255,214,0,0.35)]" data-testid="install-prompt">
      <div className="flex items-start gap-3 p-4">
        <DeviceMobile size={28} weight="fill" color="#FFD600" className="shrink-0 mt-1" />
        <div className="flex-1">
          <p className="font-display font-bold text-sm uppercase">Install the App</p>
          {isIOS ? (
            <p className="text-xs text-zinc-400 mt-1">Tap the <b>Share</b> icon, then <b>“Add to Home Screen”</b> to install Affiliated Connections.</p>
          ) : (
            <p className="text-xs text-zinc-400 mt-1">Add Affiliated Connections to your home screen for a full-screen app experience.</p>
          )}
          {hasNativePrompt && (
            <button onClick={install} data-testid="install-app-button"
              className="mt-3 flex items-center gap-1 px-3 py-2 bg-[#FFD600] text-black text-xs font-bold uppercase tracking-widest hover:bg-[#e6c200] transition-colors">
              <DownloadSimple size={14} weight="bold" /> Install
            </button>
          )}
        </div>
        <button onClick={dismiss} data-testid="install-dismiss" className="text-zinc-500 hover:text-white"><X size={18} /></button>
      </div>
    </div>
  );
}
